import { Outlet } from 'react-router-dom';
import TopNav from './TopNav';
import { Footer } from './Footer';
import { useState } from 'react';

/**
 * DefaultLayout
 * @param
 * @param
 * @constructor
 */
//
export default function DefaultLayout() {
  const [isNavHide, setIsNavHide] = useState(true);
  return (
    <>
      <TopNav variant="light" isNavHide={isNavHide}></TopNav>
      <Outlet context={{ isNavHide, setIsNavHide }} />
      <Footer />
    </>
  );
}
